import { Action, ActionReducer, ActionReducerMap, combineReducers, createFeatureSelector, createSelector, MetaReducer } from '@ngrx/store';
import * as fromGeneratePaymentMandate from './generate-payment-mandate.reducer';
import * as fromGeneratedPaymentMandateReducer from '../reducers/generate-payment-mandate.reducer';
import * as fromCheckCardStatus from './check-card-status.reducer';

export const paymentMandateFeatureKey = 'paymentMandate';

export interface PaymentMandateState {
  [fromGeneratePaymentMandate.generatePaymentMandateFeatureKey]: fromGeneratePaymentMandate.GeneratePaymentMandateState;
  [fromCheckCardStatus.checkCardStatusFeatureKey]: fromCheckCardStatus.CheckCardStatusState;
}

export interface State {
  [paymentMandateFeatureKey]: PaymentMandateState;
}

export function reducers(state: PaymentMandateState | undefined, action: Action) {
  return combineReducers({
    [fromGeneratePaymentMandate.generatePaymentMandateFeatureKey]: fromGeneratePaymentMandate.reducer,
    [fromCheckCardStatus.checkCardStatusFeatureKey]: fromCheckCardStatus.reducer
  })(state, action);
}

//Select root state
export const selectPaymentMandateState = createFeatureSelector<State, PaymentMandateState>(paymentMandateFeatureKey);

//select feature state
export const getGeneratePaymentMandateState = createSelector(
  selectPaymentMandateState,
  state => state[fromGeneratedPaymentMandateReducer.generatePaymentMandateFeatureKey]
);

export const getCheckCardStatusState = createSelector(
  selectPaymentMandateState,
  state => state[fromCheckCardStatus.checkCardStatusFeatureKey]
);
